/**
 * Created by calhosh on 4/14/2017.
 * English resource file
 */
export const labels = {};
